import { render, staticRenderFns } from "./CPDueDiligenceAccountHolderNameDetails.vue?vue&type=template&id=065d235a&scoped=true&"
import script from "./CPDueDiligenceAccountHolderNameDetails.vue?vue&type=script&lang=ts&"
export * from "./CPDueDiligenceAccountHolderNameDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065d235a",
  null
  
)

export default component.exports